module.exports = __webpack_public_path__ + "img/right_alignac.5d6b789c.svg";